import zArea from './src/main.vue';
zArea.install = (Vue) => {
	Vue.component(zArea.name, zArea);
};
export default zArea;
